import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleXMarkOutlined } from 'assets/icons';
import { HEADER_HEIGHT } from 'components/Page/Header/TopHeader/TopHeader';
import { PAGE_SIDE_BAR_ID, SIDEBAR_WIDTH } from 'components/Page/PageSideBar/PageSideBar';
import { CompareTable, CompareTableState } from 'pages/CatalogPage/IAM/FullTextSearchResult/CompareTable';
import { HeaderWrapper } from 'pages/CatalogPage/IAM/FullTextSearchResult/CompareTable.styled';
import { useWindowWidth } from 'pages/CatalogPage/IAM/FullTextSearchResult/utils';
import { SIDEBAR_ZINDEX, theme } from 'styles';
import { Icon, MarginBox, Modal, MODAL_HEADER_HEIGHT, Text } from 'UI';

export const CompareTableHeader = () => {
  const { t } = useTranslation();
  return (
    <HeaderWrapper>
      <Text type="heading3">{t('catalog.search.iam.compare_table.title', 'Comparative')}</Text>
      <Text type="h5_light">
        {t('catalog.search.iam.compare_table.description', 'Select the reference you want to compare')}
      </Text>
    </HeaderWrapper>
  );
};

export const compareTableInitialState: CompareTableState = {
  firstReference: '',
  secondReference: '',
  thirdReference: '',
};

interface CompareTableProps {
  vehicleKey?: string;
  compareTableReferences: CompareTableState;
  setCompareTableReferences: React.Dispatch<React.SetStateAction<CompareTableState>>;
  compareReferencesList?: string[];
  open?: boolean;
  onCancel?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const CompareTableModal = ({
  vehicleKey,
  compareTableReferences,
  setCompareTableReferences,
  compareReferencesList,
  open,
  onCancel,
}: CompareTableProps) => {
  const windowWidth = useWindowWidth();

  const handleSelect = (referenceNumber: string, columnIndex?: number) => {
    const secondColumnIndex = 2;
    const thirdColumnIndex = 3;
    switch (columnIndex) {
      case secondColumnIndex:
        setCompareTableReferences({ ...compareTableReferences, secondReference: referenceNumber });
        break;
      case thirdColumnIndex:
        setCompareTableReferences({ ...compareTableReferences, thirdReference: referenceNumber });
        break;
      default:
        return;
    }
  };

  const leftPosition = () => {
    const menuElement = document.getElementById(PAGE_SIDE_BAR_ID);
    if (menuElement) {
      const width = window.getComputedStyle(menuElement).width;
      return parseFloat(width);
    }
    return SIDEBAR_WIDTH;
  };

  return (
    <Modal
      title={<CompareTableHeader />}
      footer={null}
      maskClosable
      closable
      closeIcon={<Icon IconComponent={CircleXMarkOutlined} />}
      open={open}
      onCancel={onCancel}
      zIndex={SIDEBAR_ZINDEX - 1}
      width={windowWidth - leftPosition()}
      backgroundColor={theme.color.white}
      style={{
        position: 'absolute',
        top: HEADER_HEIGHT + MODAL_HEADER_HEIGHT,
        left: leftPosition(),
      }}
    >
      <MarginBox mt={48}>
        <CompareTable
          selectedReferences={compareTableReferences}
          vehicleKey={vehicleKey}
          compareReferencesList={compareReferencesList}
          handleSelect={handleSelect}
        />
      </MarginBox>
    </Modal>
  );
};
